'use client';

import NavAcessibilidade from '../../NavAcessibilidade/NavAcessibilidade';
import Menu from '../../Menu/Menu';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import Footer from '../../Footer/Footer';
import styles from './QuemSomos.module.css';
import Button from '../../Button/Button';
import classNames from 'classnames';
import Newsletter from '../../Newsletter/Newsletter';
import JornadadeAprendizagem from '../../JornadadeAprendizagem/JornadadeAprendizagem';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

interface Logo {
  src: string;
  alt: string;
}
  
interface Data {
  logos: Logo[];
}

function QuemSomosView() {
  const [logos1, setLogos1] = useState<Logo[]>([]);
  const [logos2, setLogos2] = useState<Logo[]>([]);
  const [logos3, setLogos3] = useState<Logo[]>([]);

  useEffect(() => {
    import('../../../jsons/QuemSomosEditorasSwiper1.json').then((m) => setLogos1(m.default.logos));
    import('../../../jsons/QuemSomosEditorasSwiper2.json').then((m) => setLogos2(m.default.logos));
    import('../../../jsons/QuemSomosEditorasSwiper3.json').then((m) => setLogos3(m.default.logos));
  }, []);

  useEffect(() => {
  import('../../../jsons/QuemSomosUniversidades.json')
    .then((module) => {
      setData(module.default);
    })
    .catch((error) => console.error('Erro ao carregar o JSON', error));
}, []);


  const [data, setData] = useState<Data | null>(null);

  const navigate = useRouter();

  const [direction1, setDirection1] = useState<'left' | 'right'>('right');
  const [direction2, setDirection2] = useState<'left' | 'right'>('left');
  const [direction3, setDirection3] = useState<'left' | 'right'>('right');

  useEffect(() => {
    import('../../../jsons/QuemSomosUniversidades.json')
      .then((module) => {
        setData(module.default);
      })
      .catch((error) => console.error('Erro ao carregar o JSON', error));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection1((prev) => (prev === 'right' ? 'left' : 'right'));
      setDirection2((prev) => (prev === 'left' ? 'right' : 'left'));
      setDirection3((prev) => (prev === 'right' ? 'left' : 'right'));
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const getSwiperConfig = (direction: 'left' | 'right') => ({
    modules: [Autoplay],
    slidesPerView: 6,
    spaceBetween: 16,
    loop: true,
    speed: 15000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      reverseDirection: direction === 'left',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 6,
      },
    },
  });

  if (!data) {
    return <div></div>;
  }

  return (       
    
    <div>

      <NavAcessibilidade/>
      <Menu/>
      <div id="conteudo"></div>
      <Breadcrumb titulo="Quem Somos" color="blue200"/>

      <section className={styles.quemSomos}>
        <div className={styles.uiContainer}>
            <div className={styles.BibliotecaVirtual}>
              <div className={styles.contentSobreBV}>
                <h2 className={styles.title} tabIndex={0}>A Biblioteca Virtual é uma plataforma de acervo virtual que reúne títulos com acesso ilimitado e multiusuário.</h2>
                <p tabIndex={0}>A Biblioteca Virtual da Pearson Higher Education é uma iniciativa pioneira no mercado educacional. Desde 2005, oferece uma plataforma de livros digitais interativa, dinâmica e eficiente para as instituições de ensino que desejam inserir a transformação digital no processo educativo e melhorar a experiência dos estudantes.</p>
                <p tabIndex={0}>São diversas áreas de conhecimento, tais como: administração, marketing, engenharia, direito, letras, economia, computação, educação, medicina, enfermagem, psiquiatria, gastronomia, turismo e outras.</p>
              </div>
              <div className={styles.imgContentSobre}>
                <img tabIndex={0} loading="lazy" src= "/images/sobre/sobre.png" alt="Imagem Sobre Biblioteca Virtual" aria-label="Imagem Sobre Biblioteca Virtual"/>
              </div>
            </div>

            <div className={styles.Pearson}>
              <div className={styles.contentSobrePearson}>
                <h3 className={styles.title} tabIndex={0}><span>Uma iniciativa Pearson</span> em parceria com mais de 80 editoras</h3>
                <p tabIndex={0}>A Biblioteca Virtual está atualmente disponível em mais de 950 instituições de ensino, com mais de 4 milhões de usuários ativos. Além dos títulos da Pearson, a plataforma digital conta com títulos de mais de 80 editoras parceiras.</p>
                <div className={styles.tag} tabIndex={0}>
                  As melhores soluções educacionais para ensino superior começam com P
                </div>
              </div>
              <div className={styles.imgPearson}>
              <img tabIndex={0} loading="lazy" src= "/images/sobre/pearson.png" alt="Imagem Sobre Pearson" aria-label="Imagem Sobre Pearson"/>
              </div>
            </div>
        </div>


        <div className={styles.editoras} id='Editoras'>
          <div className={styles.uiContainer}>
            <h4 className={styles.title} tabIndex={0}>Editoras</h4>
          </div>
          <div className={'containerEditoras'}>
            <Swiper {...getSwiperConfig(direction1)} className={styles.rowEditoras}>
              {logos1.map((logo, index) => (
                <SwiperSlide className={styles.itemEditora} key={index}>
                  <img tabIndex={0} loading="lazy" src={logo.src} alt={logo.alt} />
                </SwiperSlide>
              ))}
            </Swiper>
           
            <Swiper {...getSwiperConfig(direction2)} className={styles.rowEditoras}>
              {logos2.map((logo, index) => (
                <SwiperSlide className={styles.itemEditora} key={index}>
                  <img tabIndex={0} loading="lazy" src={logo.src} alt={logo.alt} />
                </SwiperSlide>
              ))}
            </Swiper>

            <Swiper {...getSwiperConfig(direction3)} className={styles.rowEditoras}>
              {logos3.map((logo, index) => (
                <SwiperSlide className={styles.itemEditora} key={index}>
                  <img tabIndex={0} loading="lazy" src={logo.src} alt={logo.alt} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          
          <Link href={'/NossoAcervo'} className={classNames('btnPadrao','btnBlue')} aria-label="Conheça nosso Acervo">Conheça nosso Acervo</Link>
          
        </div>

            <div className={styles.necessidade}>
              <div className={styles.uiContainer}>
                <div className={styles.dFlex}>
                  <div className={styles.imgNecessidade}>
                    <img tabIndex={0} loading="lazy" src= "/images/img-necessidade.png" alt="Imagem representando necessidade de soluções personalizadas"/>
                  </div>
                  <div className={styles.contentNecessidade}>
                    <h2 className={styles.title} tabIndex={0}>Para cada necessidade, uma solução personalizada.</h2>
                    <p tabIndex={0}>Oferecemos soluções sob medida para Instituições de Ensino Superior, Ensino Técnico e Empresas, com ferramentas inteligentes e direcionadas.</p>
                    <p tabIndex={0}>Estamos conectados aos nossos clientes, compreendendo suas demandas e oferecendo soluções que transformam desafios em sucesso.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.boxLogos} id='Universidades'>
              <div className={styles.uiContainer}>
                <div className={styles.dFlex}>
                  <div className={styles.contentLogos}>
                    <h3 className={styles.title} tabIndex={0}>Universidades</h3>
                    <p tabIndex={0}>As principais instituições de ensino superior do país confiam na Biblioteca Virtual para transformar a jornada de aprendizado de seus alunos. Nossa parceria fortalece a conexão entre conhecimento, inovação e resultados de excelência.</p>
          <Link href={'/Produtos/EnsinoSuperior'} className={classNames('btnPadrao','btnBlue')} aria-label="Para Instituições de Ensino Superior">Saiba mais</Link>
                  </div>

                  <div className={styles.containerLogos}>
                    {data.logos.map((logo, index) => (
                      <div key={index} className={styles.itemLogo}>
                        <img tabIndex={0} loading="lazy" src={logo.src} alt={logo.alt ? logo.alt : "Logo de universidade parceira"} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.boxLogos}>
              <div className={styles.uiContainer}>
                <div className={styles.dFlex}>
                  <div className={styles.contentLogos}>               
                    <img tabIndex={0} loading="lazy" src= "/images/Instituto_Federal.png" alt="Logo do Instituto Federal" className={styles.logoIF}/>
                    <h3 className={styles.title} tabIndex={0}>Institutos Federais</h3>
                    <p tabIndex={0}>A Biblioteca Virtual está expandindo sua presença nos Institutos Federais, levando inovação e praticidade ao ensino técnico e tecnológico. Nosso acervo e ferramentas inteligentes estão prontos para apoiar os institutos em sua missão educacional.</p>
          <Link href={"/Produtos/EnsinoTecnico"} className={classNames('btnPadrao','btnBlue')} aria-label="Para Instituições de Ensino Técnico">Saiba mais</Link>
                  </div>

                  <div className={styles.containerNomesInstituicoesFederais}>
                    <p tabIndex={0}>Instituto Federal <span>Acre</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Baiano</span></p> 
                    <p tabIndex={0}>Instituto Federal <span>Brasília</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Catarinense</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Ceará</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Espírito Santo</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Goiano</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Goiás</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Maranhão</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Mato Grosso do Sul</span></p>      
                    <p tabIndex={0}>Instituto Federal <span>Minas Gerais</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Norte de Minas Gerais</span></p> 
                    <p tabIndex={0}>Instituto Federal <span>Paraná</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Pernambuco</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Rio Grande do Sul</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Roraima</span></p>
                    <p tabIndex={0}>Instituto Federal <span>São Paulo</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Sergipe</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Sul de Minas Gerais</span></p>
                    <p tabIndex={0}>Instituto Federal <span>Sul-Rio-Grandense</span></p>       
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.performance}>
              <div className='uiContainer'>
                <div className={styles.dFlex}>
                  <div className={styles.contentPerfomance}>
                    <h2 className={styles.title} tabIndex={0}>Excelência em Performance, Qualidade e Segurança</h2>
                    <p tabIndex={0}>Nosso ambiente virtual adota altos padrões de qualidade e segurança. Utilizamos uma estrutura de hospedagem robusta e atualizada com as melhores práticas de mercado.</p>
                    <p tabIndex={0}>Garantimos alta disponibilidade, acessibilidade e rigorosos padrões de segurança, em total conformidade com a LGPD (Lei Geral de Proteção de Dados).</p>
                  </div>

                  <div className={styles.imgPerfomance}>
                    <img tabIndex={0} loading="lazy" src= "/images/img-performance.png" alt="Imagem representando performance, qualidade e segurança"/>
                  </div>
                </div>
              </div>
            </div>
      
      </section> 

      <JornadadeAprendizagem/>
      <Newsletter/>
      <Footer/>
    </div>
  );
}

export default QuemSomosView;
